import { Navigate } from "react-router-dom";

import { useAuth } from "../core/auth";
import BrandLayout from "../Routes/brand/layout";
import BrandDashboard from "../Routes/brand-dashboard/page";
import BrandLogin from "../Routes/brand/login/page";
import ContractDetail from "../Routes/brand-dashboard/contract/[contractId]/page";
import BrandDashboardCampaignDetail from "../Routes/brand-dashboard/campaign/[campaignId]/page";
import SettlementDetail from "../Routes/brand-dashboard/settlements/[settlementId]/page";

const BrandAuth = ({ children }: { children: JSX.Element }) => {
  const { isBrandLoggedIn } = useAuth();

  if (isBrandLoggedIn) {
    return <BrandLayout>{children}</BrandLayout>;
  }

  return <Navigate to="/brand/login" />;
};

// prettier-ignore
export const brandRoutes = [
  {
    path: "/brand/login",
    element: <BrandLogin />,
  },
  {
    path: "/brand-dashboard",
    element: (
      <BrandAuth>
        <BrandDashboard />
      </BrandAuth>
    ),
  },
  {
    path: "/brand-dashboard/settlements",
    element: (
      <BrandAuth>
        <BrandDashboard />
      </BrandAuth>
    ),
  },
  {
    path: "/brand-dashboard/settlements/:settlementId",
    element: (
      <BrandAuth>
        <SettlementDetail />
      </BrandAuth>
    ),
  },
  {
    path: "/brand-dashboard/members",
    element: (
      <BrandAuth>
        <BrandDashboard />
      </BrandAuth>
    ),
  },
  {
    path: "/brand-dashboard/campaign/:campaignId",
    element: (
      <BrandAuth>
        <BrandDashboardCampaignDetail />
      </BrandAuth>
    ),
  },
  {
    path: "/brand-dashboard/contract/:contractId",
    element: (
      <BrandAuth>
        <ContractDetail />
      </BrandAuth>
    ),
  },
];
